// App.js
import React, { useState, useEffect } from 'react';
import Graboncampaign from './graboncampaign1';
import './webprofile.css';
import {
    BrowserRouter as Router,
    Link,
    Route,
    Routes,
    useParams,
  } from "react-router-dom";
const Templaterenderer = () => {
    const [data, setData] = useState(null);
    const [template, setTemplate] = useState(null);
    const [busdata,setbusdata]=useState(null)
    const { id } = useParams();
  
    const showLoader = () => {
      return (
        <div className="bouncing-ball">
          
        
        <div className="bouncing-ball">
          
          </div>
        </div>
      );
    }
  useEffect(() => {
    const fetchData = async () => {
     /* if (id.split('_')[0]=='mo'||id.split('_')[0]=='so'){
        window.location.href='https://jiffypay-in.jiffynexus.com/'+id
      }
       if (id.split('_')[0]=='ms'){
        window.location.href='https://jiffychat-in.jiffynexus.com/'+id
      }*/
      //else {
      try {
        const host = window.location.hostname;
            console.log('subdomain',host)
        const response=await fetch(`https://us-central1-jiffybook-common.cloudfunctions.net/getpublicbusinesswebsectiondata?parameter=${host}`) 
        const result = await response.json();
         console.log('subdatafetched',result)
       
      
        
          if(result.country=='IN'){
       /*     if (id.split('_')[0]=='mo'||id.split('_')[0]=='so'){
        window.location.href='https://'+result.busdata.paymenturl+'/'+id//'https://jiffypay-in.jiffynexus.com/'+id
      }
      else if (id.split('_')[0]=='ms'||id.split('_')[0]=='mc'){
       console.log(result.busdata.chaturl)
         window.location.href='https://'+result.busdata.chaturl+'/'+id//'https://jiffychat-in.jiffynexus.com/'+id
      }*/
      
                const response1=await fetch(`https://us-central1-jiffybook-india.cloudfunctions.net/getcampaigndata?parameter=${id}`)
                const result1 = await response1.json();
                //setData(result1.data); 
        /*        const response=await fetch(`https://us-central1-jiffybook-india.cloudfunctions.net/getsubdomainprofiledata?parameter=${host}`)
                const result = await response.json();*/
                //setbusdata(result.busdata)
                const combinedData = {
                  ...result1.data,
                  ...result.busdata,
                };
                
                setData(combinedData);
               // console.log('fetching',result1.data,result.busdata)
                setTemplate(result1.data.Template)
            
          }
       
        if(result.country=='EE'){
          
         /*   if (id.split('_')[0]=='mo'||id.split('_')[0]=='so'){
        window.location.href=window.location.href='https://'+result.busdata.paymenturl+'/'+id
      }
      else if (id.split('_')[0]=='ms'||id.split('_')[0]=='mc'){
        window.location.href=window.location.href='https://'+result.busdata.chaturl+'/'+id
      }*/
          const response1=await fetch(`https://us-central1-jiffybook-app.cloudfunctions.net/getcampaigndata?parameter=${id}`)
          const result1 = await response1.json();
         /* const response=await fetch(`https://us-central1-jiffybook-app.cloudfunctions.net/getsubdomainprofiledata?parameter=${host}`)
                const result = await response.json();*/
                setbusdata(result.busdata)
          setData(result1.data); 
          setTemplate(result1.data.Template)
        
      }
        if(result.country=='AE'){
          
        /*    if (id.split('_')[0]=='mo'||id.split('_')[0]=='so'){
        window.location.href=window.location.href='https://'+result.busdata.paymenturl+'/'+id
      }
      else if (id.split('_')[0]=='ms'||id.split('_')[0]=='mc'){
        window.location.href=window.location.href='https://'+result.busdata.chaturl+'/'+id
      }*/
      
          const response1=await fetch(`https://us-central1-jiffybook-uae.cloudfunctions.net/getcampaigndata?parameter=${id}`)
          const result1 = await response1.json();
         /* const response=await fetch(`https://us-central1-jiffybook-app.cloudfunctions.net/getsubdomainprofiledata?parameter=${host}`)
                const result = await response.json();*/
                setbusdata(result.busdata)
          setData(result1.data); 
          setTemplate(result1.data.Template)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
   // }
    };

    fetchData();
    }, []);
  
    if (!data) {
      return  <div style={{marginLeft:"45%",marginTop:'20%'}}>
      <div className="bouncing-ball">
        {showLoader()}
        </div>
     </div>;
    }
    switch (template) {
        case 'A':
          return <Graboncampaign data={data} />;
      
        default:
          return  <Graboncampaign data={data} />;
      }

};

export default Templaterenderer;
